import { PropsWithChildren } from 'react';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, LocalizationProviderProps } from '@mui/x-date-pickers/LocalizationProvider';

export type DateFnsProviderProps = Omit<LocalizationProviderProps, 'dateAdapter'>;

function DateFnsProvider({ children, ...props }: PropsWithChildren<DateFnsProviderProps>) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} {...props}>
      {children}
    </LocalizationProvider>
  );
}

export default DateFnsProvider;
